import { postJson } from '../../http'

/**
 * 用户认证API
 */
export default {
    /**
     * 企业认证
     * @param {*} data 
     */
    companyAuth(data) {
        return postJson('/lz/account/actAndAuth/companyAuth', data)
    },
    /**
     * 工程公司认证
     * @param {*} data 
     */
    enginnerCompanyAuth(data) {
        return postJson('/lz/account/actAndAuth/engineeringCompanyAuth', data)
    },
    /**
     * 材料供应商认证
     * @param {*} data 
     */
    materialSupplierAuth(data) {
        return postJson('/lz/account/actAndAuth/materialSupplierAuth', data)
    },
    /**
     * 实名认证
     * @param {*} data 
     */
    realNameAuth(data) {
        return postJson('/lz/account/actAndAuth/realNameAuth', data)
    },
    /**
     * 查看认证状态列表
     *
     * @param {*} data
     * @returns
     */
    fetchAuthStatusList(data) {
        return postJson('/lz/account/accountProfile/queryCompanyAuthStatus', data)
    },
    /**
     * 查看实名认证状态
     *
     * @param {*} data
     * @returns
     */
    fetchRealNameAuthStatus(data) {
        return postJson('/lz/account/accountProfile/queryRealNameAuthStatus', data)
    },
    /**
     * 查看企业认证信息
     *
     * @param {*} data
     * @returns
     */
    fetchEnterpriseAuthInfo(data) {
        return postJson('/lz/account/accountProfile/queryCompanyAuthInfo', data)
    },
    /**
     *  企业认证URL
     *
     * @returns
     */
    enterpriseAuthInfoUrl() {
        return '/lz/account/accountProfile/queryCompanyAuthInfo'
    },
    /**
     * 查看工程公司认证信息
     *
     * @param {*} data
     * @returns
     */
    fetchEnginnerAuthInfo(data) {
        return postJson('/lz/account/accountProfile/queryEngineeringCompanyInfo', data)
    },
    /**
     *  工程公司认证URL
     *
     * @returns
     */
    enginnerAuthInfoUrl() {
        return '/lz/account/accountProfile/queryEngineeringCompanyInfo'
    },
    /**
     * 查看材料供应商认证信息
     *
     * @param {*} data
     * @returns
     */
    fetchMaterialAuthInfo(data) {
        return postJson('/lz/account/accountProfile/queryMaterialSupplierInfo', data)
    },
    /**
     *  材料供应商认证URL
     *
     * @returns
     */
    materialAuthInfoUrl() {
        return '/lz/account/accountProfile/queryMaterialSupplierInfo'
    },
    /**
     * 查看实名认证信息
     *
     * @param {*} data
     * @returns
     */
    fetchRealNameAuthInfo(data) {
        return postJson('/lz/account/accountProfile/queryRealNameAuthInfo', data)
    },
    /**
     *  实名认证URL
     *
     * @returns
     */
    realNameAuthInfoUrl() {
        return '/lz/account/accountProfile/queryRealNameAuthInfo'
    },
    /**
     * 查看用户概况
     *
     * @param {*} data
     * @returns
     */
    fetchUserSurveyInfo(data) {
        return postJson('/lz/account/accountProfile/queryUserAccount', data)
    },
    /**
     * 查看企业认证审批记录
     *
     * @param {*} data
     * @returns
     */
    fetchEnterpriseAuthLog(data) {
        return postJson('/lz/account/accountProfile/queryCompanyAuthApprovalLog', data)
    },
    /**
     * 查看工程公司认证审批记录
     *
     * @param {*} data
     * @returns
     */
    fetchEnginnerAuthLog(data) {
        return postJson('/lz/account/accountProfile/queryEngineeringCompanyApprovalLog', data)
    },
    /**
     * 查看材料供应商公司认证审批记录
     *
     * @param {*} data
     * @returns
     */
    fetchMaterialAuthLog(data) {
        return postJson('/lz/account/accountProfile/queryMaterialSupplierApprovalLog', data)
    },
    /**
     * 查看实名认证审批记录
     *
     * @param {*} data
     * @returns
     */
    fetchRealNameAuthLog(data) {
        return postJson('/lz/account/accountProfile/queryRealNameApprovalLog', data)
    },
    /**
     * 校验企业/组织名称是否重复
     *
     * @param {*} data
     * @returns
     */
    checkCompanyNameExist(data) {
        return postJson('/lz/account/actAndAuth/checkCompanyName', data)
    },
    /**
     * 上传头像
     *
     * @param {*} data
     * @returns
     */
    uploadHeadPortrait(data) {
        return postJson('/lz/account/actAndAuth/headPortrait', data)
    },
    /**
     * 实名认证数据回填
     *
     * @param {*} data
     * @returns
     */
    fetchRealNameWriteBack(data) {
        return postJson('/lz/account/accountProfile/realNameInfoWriteBack', data)
    },
    /**
     * 查询企业资质列表
     *
     * @returns
     */
    fetchQualification() {
        return postJson('/lz/account/actAndAuth/queryQualification')
    },
    /**
     * 查询劳务认证工程经营范围列表
     *
     * @param {*} params
     * @returns
     */
    fetchLaborQualification() {
        return postJson('/lz/account/actAndAuth/queryLabourQualification')
    },
    /**
     * 劳务认证提交
     *
     * @param {*} params
     * @returns
     */
    laborAuth(params) {
        return postJson('/lz/account/actAndAuth/labourCompanyAuth', params)
    },
    /**
     * 查询劳务认证审核日志
     *
     * @param {*} params
     * @returns
     */
    fetchLaborApprovalLog(params) {
        return postJson('/lz/account/accountProfile/queryLabourCompanyApprovalLog', params)
    },
    /**
     * 劳务认证信息url
     *
     * @returns
     */
    laborAuthInfoUrl() {
        return '/lz/account/accountProfile/queryLabourCompanyInfo'
    },
    /**
     * 查询劳务认证信息
     *
     * @param {*} params
     * @returns
     */
    fetchLaborAuthInfo(params) {
        return postJson('/lz/account/accountProfile/queryLabourCompanyInfo', params)
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/user/auth.js